import HomePage       from '@/components/pages/HomePage.vue';
import PricingPage    from '@/components/pages/PricingPage.vue';
import AllBeatsPage   from '@/components/pages/AllBeatsPage.vue';
import ContactPage    from '@/components/pages/ContactPage.vue';
import SingleBeat     from '@/components/pages/SingleBeat.vue';
import SearchResults  from '@/components/pages/SearchResultsPage.vue';
import BlogPage       from '@/components/pages/BlogPage.vue';
import ContentPage    from '@/components/pages/ContentPage.vue';
import StaticPage     from '@/components/pages/StaticPage.vue';
import UpgradeLicensePage from '@/components/pages/UpgradeLicensePage.vue';

const contentRoutes = ( ui_data.contentRoutes || [] ).map( function ( item ) {
	return {
		path: item.path,
		name: 'content-' + item.type + '-' + item.id,
		component: ContentPage,
		props: {
			id: item.id,
			type: item.type,
		},
		meta: {
			spa: true,
			title: item.title,
		},
	};
} );

const staticRoutes = ( ui_data.staticPages || [] ).map( function ( item ) {
	return {
		path: item.path,
		name: 'static-' + item.slug,
		component: item.slug === 'upgrade-license' ? UpgradeLicensePage : StaticPage,
		props: {
			slug: item.slug,
		},
		meta: {
			spa: true,
			title: item.title,
		},
	};
} );

// Define routes
export default [
	{
		path: ui_data.site_url_relative,
		name: 'home',
		component: HomePage,
		props: route => ({ modules: ui_data.homePageModules }),
		meta: {
			title: ui_data.siteName + ' - Home',
			metaTags: [
				{
					name: 'description',
					content: ui_data.siteDescription,
				},
				{
					property: 'og:description',
					content: ui_data.siteDescription,
				}
			]
		}
	},
	{
		path: ui_data.site_url_relative + 'search',
		name: 'search',
		component: SearchResults,
		props: route => ({ query: route.query.q }),
		meta: {
			title: ui_data.siteName + ' - Search',
			metaTags: [
				{
					name: 'description',
					content: 'Search for Beats'
				},
				{
					property: 'og:description',
					content: 'Search for Beats'
				}
			]
		}

	},
	{
		path: ui_data.site_url_relative + 'beats',
		component: AllBeatsPage,
		name: 'allbeats',
		meta: {
			title: ui_data.siteName + ' - All Beats',
			metaTags: [
				{
					name: 'description',
					content: 'Browse All Beats'
				},
				{
					property: 'og:description',
					content: 'Browse All Beats'
				}
			]
		}
	},
	{
		path: ui_data.site_url_relative + 'pricing',
		name: 'pricing',
		component: PricingPage,
		meta: {
			title: ui_data.siteName + ' - Pricing',
			metaTags: [
				{
					name: 'description',
					content: 'View Pricing Details'
				},
				{
					property: 'og:description',
					content: 'View Pricing Details'
				}
			]
		}
	},
	{
		path: ui_data.site_url_relative + 'contact',
		name: 'contact',
		component: ContactPage,
		meta: {
			title: ui_data.siteName + ' - Contact',
			metaTags: [
				{
					name: 'description',
					content: 'Contact Us'
				},
				{
					property: 'og:description',
					content: 'Contact Us'
				}
			]
		}
	},
	{
		path: ui_data.site_url_relative + 'beats/:genre/',
		name: 'genre',
		component: AllBeatsPage,
		props: true,
	},
	{
		path: ui_data.site_url_relative + 'mood/:mood/',
		name: 'mood',
		component: AllBeatsPage,
		props: true,
	},
	{
		path: ui_data.site_url_relative + 'beats/tag/:tag/',
		name: 'tag',
		component: AllBeatsPage,
		props: true,
	},
	{
		path: ui_data.site_url_relative + 'downloads/:name/',
		name: 'singledownload',
		component: SingleBeat,
		meta: {
			title: ui_data.siteName + ' - ' + ui_data.pageName,
			metaTags: [
				{
					name: 'description',
					content: ''
				},
				{
					property: 'og:description',
					content: ''
				},
				{
					property: 'og:title',
					content: '',
				},
				{
					property: 'og:image',
					content: '',
				}
			]
		}
	},
	{
		path: ui_data.site_url_relative + 'blog',
		name: 'blog',
		component: BlogPage,
		meta: {
			spa: true,
			title: ui_data.siteName + ' - Blog',
		}
	},
	{
		path: ui_data.site_url_relative + 'fr',
		name: 'french',
		component: HomePage,
		meta: {
			title: ui_data.siteName + ' - Home',
			metaTags: [
				{
					name: 'description',
					content: ui_data.siteDescription
				},
				{
					property: 'og:description',
					content: ui_data.siteDescription
				}
			]
		}
	},
	...contentRoutes,
	...staticRoutes,
];